import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {CssBaseline} from '@material-ui/core';
import './index.css';
import Exam from './pages/exam';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";

function App() {
    return (
        <Router>
            <Route exact path={"/de-thi-:alias-exam:exam_id.html"} component = {Exam}></Route>
        </Router>
    );
}

export default App;
